import OtRoot from "components/OtRoot.vue";
import xamatron from "xamatron";
xamatron.ready(function () {
    new OtRoot().$mount("#root");
});



//////////////////
// WEBPACK FOOTER
// ./app/ts/main.ts
// module id = 176
// module chunks = 0